module.exports = __webpack_public_path__ + "img/sicranoColor.6d74c984.png";